export default __webpack_public_path__ + "128fd2d0ea4f9ed9bd65066b9f801db3.png";